// extracted by css-extract-rspack-plugin
export default {"qrCode":"qr-code--eqvNxqkL1c0HvRvh","messengerItem":"messenger-item--lJZEu4nJ84UBpDto"};